import script from "./TressCartPopUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCartPopUp.vue?vue&type=script&lang=ts&setup=true"

import "./TressCartPopUp.vue?vue&type=style&index=0&id=61565eb6&lang=scss"

const __exports__ = script;

export default __exports__